import { render } from "./ActionPopOver.vue?vue&type=template&id=ec018d0a&scoped=true"
import script from "./ActionPopOver.vue?vue&type=script&lang=js"
export * from "./ActionPopOver.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec018d0a"]])

export default __exports__